import { OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import BaseFacet from '../BaseFacet/BaseFacet';
import FacetType from '../../../utility/types/facetType';
import { facetTypeDetails } from '../../../utility/types/facetTypeDetails';
import { store } from '../../../redux/store';
/* istanbul ignore next */
class DeviceLinkConnectionFacet extends BaseFacet {
  constructor() {
    super();
    this.facetType = FacetType.DEVICE_LINK_CONNECTION;
    this.displayName = 'Link Connection';
    this.description = 'Include devices that...';
    this.state = store.getState();
  }

  // eslint-disable-next-line class-methods-use-this
  getOperatorDescription(operatorType) {
    const operatorTypeId = parseInt(operatorType, 10);
    const operatorDescriptions = {
      [OperatorTypes.EQUAL_TO_VALUE]: 'are connected to',
      [OperatorTypes.NOT_EQUAL_TO]: 'are NOT connected to',
    };
    return operatorDescriptions[operatorTypeId] || '';
  }

  getDisplayValue1(value) {
    const links = this.state.linkList.linkList;
    const foundLink = links.find((link) => link.id === value);
    return foundLink ? foundLink.name : 'any Link installation';
  }

  fromDisplayValue1(value) {
    const links = this.state.linkList.linkList;
    const result = links.find((link) => link.name === value);
    return result ? result.id : -1;
  }

  getOperatorSelectOptions() {
    const facet = facetTypeDetails[this.facetType];
    return [
      {
        value: facet.validOperators[0],
        label: this.getOperatorDescription(facet.validOperators[0]),
      },
      {
        value: facet.validOperators[1],
        label: this.getOperatorDescription(facet.validOperators[1]),
      },
    ];
  }

  getValueSelectOptions() {
    const links = this.state.linkList.linkList;
    return links.map((link) => ({
      label: link.name,
      value: link.id,
    }));
  }

  // eslint-disable-next-line class-methods-use-this
  getTooltip(filtersByOperatorObj) {
    if (filtersByOperatorObj && Object.values(filtersByOperatorObj).length) {
      const filtersArray = Object.values(filtersByOperatorObj)[0];
      const filter = filtersArray[0];
      if (filter.operatorId === OperatorTypes.EQUAL_TO_VALUE) {
        // filter by specific link installation and EQUAL_TO
        if (filtersArray[0].value1 !== '') {
          return `Device is Connected To ANY of ${filtersByOperatorObj[OperatorTypes.EQUAL_TO_VALUE]
            .map((f) => this.getDisplayValue1(f.value1))
            .join(', ')
          };`;
        }
        // filter by any link installation and EQUAL_TO
        return 'Device is Connected To a Link.';
      }
      // filter by specific link installation and NOT_EQUAL_TO
      if (filtersArray[0].value1 !== '') {
        return `Device is NOT Connected To ANY of ${filtersByOperatorObj[OperatorTypes.NOT_EQUAL_TO]
          .map((f) => this.getDisplayValue1(f.value1))
          .join(', ')
        };`;
      }
      // filter by NOT_EQUAL_TO
      return 'Device is NOT Connected To a Link.';
    }
    return '';
  }
}
export default DeviceLinkConnectionFacet;
